






import { defineComponent, onMounted } from "@vue/composition-api";
import providers from "@/lib/providers";
import config from "@/config";

export default defineComponent({
  name: "PageLoginToken",
  props: {
    userId: { type: String, required: true },
  },
  setup(props) {
    onMounted(async () => {
      const token = await providers.LoginProvider.longLiveTokenByUser(props.userId);
      window.location.replace(`${config.clientSideUrl}/login/token/${token}`);
    });
  },
});
